export default {
  placeholder: 'Rezept auswählen',
};
